import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { LogCategory, LogCoreComponent, LoggerService, LogType } from '../services/logger.service';
import { ProfileService } from '../services/profile.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {

    constructor(
        public auth: AuthenticationService,
        public profile: ProfileService,
        public logger: LoggerService
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreComponent, LogCoreComponent.Login, category);
    }

    ngOnInit() {
        this.log("ngOnInit", "Logout user", LogCategory.Init);
        this.auth.logout( false );
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", null, LogCategory.Destroy);
    }
}
